// Строка-статус сцены — ПОД шапкой виджета, над промптом (прежде — строка персонажа).
//
// Всегда видима, полный текст переносится, на мобиле работает без наведения. Две важности:
//   • blocking (красная) — сцена не подходит модели по существу (i2v «первый кадр»), «Создать»
//     заблокирована; даём действие «Убрать сцену»;
//   • обычная (жёлтая) — оговорка: несколько персонажей, часть ассетов словами, обрезка до одного фото.
// Состояние — из модульного стора; снятие шлём событием (применение держит useSceneApply).
import { requestSceneRemove, useScene } from '../../../api/sceneSelection'

export default function SceneNotice() {
	const scene = useScene()
	if (!scene || scene.warnings.length === 0) return null

	const blocked = scene.blocked
	const text = scene.warnings.map((w) => w.message).join(' ')

	return (
		<div className={`char-notice${blocked ? ' char-notice--block' : ''}`} role={blocked ? 'alert' : 'status'}>
			<span className="char-notice__icon" aria-hidden="true">
				{blocked ? (
					// Круг с «!» — «нельзя/стоп»
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
						<circle cx="12" cy="12" r="9" />
						<path d="M12 7.5v5" />
						<path d="M12 16.5h.01" />
					</svg>
				) : (
					// Треугольник-предупреждение
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M10.3 3.9 1.8 18.6A2 2 0 0 0 3.5 21.6h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
						<path d="M12 9v4.5" />
						<path d="M12 17.5h.01" />
					</svg>
				)}
			</span>
			<span className="char-notice__text">{text}</span>
			{blocked && (
				<button type="button" className="char-notice__action" onClick={() => requestSceneRemove()}>
					{scene.assets.length > 1 ? 'Убрать сцену' : 'Убрать из сцены'}
				</button>
			)}
		</div>
	)
}
